// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-5488070b]{border:none;border-radius:8px;color:#fff;padding:6px 12px;background:#c91919}button.secondary[data-v-5488070b]{background:#939393}", ""]);
// Exports
module.exports = exports;
